/**
 * GrowthOS migration — Brands master data (day-one slice)
 * ------------------------------------------------------------------
 * Backend module: GROWTHOS_ADMIN (see MongoUser.Access_Modules /
 * GrowthOsBrandController, mounted at /api/growthos-admin/brands — shared
 * by every GrowthOS admin-surface controller, not one constant per data
 * type. Deliberately NOT /api/growthos/, which is the separate, live
 * GrowthOsReportingController the still-running standalone GrowthOS
 * app polls today).
 */

export const ACCESS = { ADMIN: 'GROWTHOS_ADMIN' }

// ⚠️ TEMP testing bypass — flip to `true` once the backend actually issues
// GROWTHOS_ADMIN in a real user's JWT. While false, the sidebar item + route
// are open to any logged-in user (same pattern as D2C_ROLE_GATING).
export const GROWTHOS_ROLE_GATING = false

export const PATHS = {
  brands: '/growthos/brands',
}

export const SEGMENTS = ['SME', 'ENTERPRISE']
export const STATUSES = ['ACTIVE', 'ARCHIVED']
export const DEAL_LINK_SOURCES = ['MANUAL', 'HUBSPOT', 'SHEET']
